import rfdc from "rfdc";
const clone = rfdc();

export function deepCloneObject<ObjectType>(object: ObjectType): ObjectType {
  return clone(object);
}
